"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContext = exports.langStorageIndex = void 0;
const react_1 = __importStar(require("react"));
const i18n_1 = __importDefault(require("../../i18n"));
const http_requests_1 = require("../http-requests");
const axios_1 = __importDefault(require("axios"));
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const pageConfig_1 = require("../../store/ducks/pageConfig");
const authPersist_1 = require("../../store/ducks/authPersist");
const auth_1 = require("../../store/ducks/auth");
const AppContext = (0, react_1.createContext)(undefined);
exports.langStorageIndex = 'i18nextLng';
const AppContextProvider = ({ children, }) => {
    const instituicao = (0, react_redux_1.useSelector)((state) => state.instituicao.data);
    let inSessionLang = localStorage.getItem(exports.langStorageIndex);
    const [accessByAccessibilityDetails, setAccessByAccessibilityDetails] = (0, react_1.useState)(false);
    const [serviceData, setServiceData] = (0, react_1.useState)(null);
    const [faqsData, setFaqsData] = (0, react_1.useState)(null);
    const [featuredData, setFeaturedData] = (0, react_1.useState)(null);
    const [newsData, setNewsData] = (0, react_1.useState)(null);
    const [onGoBackMobile, setOnGoBackMobile] = (0, react_1.useState)(null);
    const [mobileView, setMobileView] = (0, react_1.useState)(null);
    const [sectionsData, setSectionsData] = (0, react_1.useState)(null);
    const [isMobile, setIsMobile] = (0, react_1.useState)(window.innerWidth <= 767);
    const [base, setBase] = (0, react_1.useState)(null);
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(null);
    const [headerTitle, setHeaderTitle] = (0, react_1.useState)(null);
    const [prefiltersData, setPrefiltersData] = (0, react_1.useState)(null);
    const [lang, setLang] = (0, react_1.useState)(inSessionLang);
    const observer = (0, react_1.useRef)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const changeHeaderTitle = (headerTitle) => setHeaderTitle(headerTitle);
    const [showDestaques, setShowDestaques] = (0, react_1.useState)(true);
    const [siglaInstituicao, setSiglaInstituicao] = (0, react_1.useState)();
    const guiasPesquisaRx = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pageConfig) === null || _a === void 0 ? void 0 : _a.guiasPesquisa; });
    const authData = (0, react_redux_1.useSelector)((state) => state.auth);
    const authPersistData = (0, react_redux_1.useSelector)((state) => state.authPersist);
    const atvLang = (0, react_redux_1.useSelector)((state) => state.pageConfig.atvLang);
    const isLoggedIn = (authData === null || authData === void 0 ? void 0 : authData.user) || (authPersistData === null || authPersistData === void 0 ? void 0 : authPersistData.user);
    // eslint-disable-next-line no-nested-ternary
    const loggedInType = (authData === null || authData === void 0 ? void 0 : authData.user) ? 'tmp' : (authPersistData === null || authPersistData === void 0 ? void 0 : authPersistData.user) ? 'auth' : null;
    (0, react_1.useEffect)(() => {
        setSiglaInstituicao(instituicao === null || instituicao === void 0 ? void 0 : instituicao.sigla_instituicao);
    }, [instituicao]);
    //Busca as atividades publicas ao alterar idioma para o correto funcionamento das traduções
    (0, react_1.useEffect)(() => {
        //Evita busca duplicada
        if (lang === atvLang) {
            return;
        }
        http_requests_1.ParametrosAPI.buscarFuncionalidades()
            .then(response => {
            store_1.Store.dispatch((0, pageConfig_1.insertAtividades)(response.data));
            store_1.Store.dispatch((0, pageConfig_1.changeAtvLang)(lang));
        })
            .catch(error => console.error(error));
    }, [lang, atvLang]);
    //Busca as atividades privadas ao alterar idioma para o correto funcionamento das traduções
    (0, react_1.useEffect)(() => {
        //Evita duplicação na busca de dados
        if (loggedInType === 'tmp' && authPersistData.atvLang === lang ||
            loggedInType === 'auth' && authData.atvLang === lang) {
            return;
        }
        if (isLoggedIn) {
            http_requests_1.PessoaAPI.getAuthPermissions().then((response) => {
                const { authPermissions } = response.data;
                store_1.Store.dispatch(loggedInType === 'tmp' ?
                    auth_1.AuthSession.storeAuthPermissions(authPermissions) :
                    authPersist_1.AuthPersist.storeAuthPermissions(authPermissions));
                store_1.Store.dispatch(loggedInType === 'tmp' ?
                    auth_1.AuthSession.storeAtvLang(lang) :
                    authPersist_1.AuthPersist.storeAtvLang(lang));
            }).catch((error) => {
                console.log('Error on get auth permisson');
            });
        }
    }, [isLoggedIn, loggedInType, lang]);
    (0, react_1.useEffect)(() => {
        const { pathname, search } = history.location;
        const searchParams = new URLSearchParams(search);
        const query = searchParams.get('q');
        if (selectedTab === 'kids') {
            if (/catalogos\/kids\/\d+\/(\d+(\.\d+){0,2})/.test(pathname)) {
                setShowDestaques(false);
            }
            else {
                setShowDestaques(true);
            }
        }
        else if (/\/acervo\/\d+/.test(pathname) || pathname === '/novas_aquisicoes' || query) {
            setShowDestaques(false);
        }
        else {
            setShowDestaques(true);
        }
    }, [history.location, selectedTab]);
    (0, react_1.useEffect)(() => {
        switch (mobileView) {
            case 'login':
                changeHeaderTitle(t('Login'));
                break;
            case 'suggestions_and_links':
                changeHeaderTitle(t('MobileLayout.LinksESugestoes'));
                break;
            case 'featured_and_news':
                changeHeaderTitle(t('MobileLayout.DestaquesENoticias'));
                break;
            case 'services':
                changeHeaderTitle(t('MobileLayout.Atendimento'));
                break;
            case 'faqs':
                changeHeaderTitle(t('DuvidasFrequentes'));
                break;
            case 'search':
                changeHeaderTitle(t('Pesquisas'));
                break;
            default:
                changeHeaderTitle(null);
        }
    }, [mobileView]);
    (0, react_1.useEffect)(() => {
        observer.current = new ResizeObserver(() => {
            const { innerWidth } = window;
            setIsMobile(innerWidth <= 767);
        });
        observer.current.observe(document.body);
        return () => {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (mobileView !== null) {
            urlSearchParams.set('mobileView', mobileView);
        }
        else {
            if (urlSearchParams.has('mobileView')) {
                setMobileView(urlSearchParams.get('mobileView'));
            }
            else {
                urlSearchParams.delete('mobileView');
            }
        }
    }, [mobileView]);
    if (inSessionLang === undefined) {
        inSessionLang = process.env.DEFAULT_LANGUAGE || 'pt';
        localStorage.setItem(exports.langStorageIndex, inSessionLang);
    }
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        const { token } = cancelTokenSrc;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            fetchServiceData(token);
            fetchFaqsData(token);
            fetchPrefiltersData(token);
        }))();
    }, [lang]);
    /**
     * Obtem dados de atendimento
     * @param token
     */
    const fetchServiceData = (token) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // @ts-ignore
            const response = yield http_requests_1.ParametrosAPI.buscaDadosSecao2('C', 0, token);
            const { data } = response;
            if (data && data.length > 0) {
                setServiceData(data);
            }
        }
        catch (error) {
            if (!axios_1.default.isCancel(error)) {
                console.log('error on request service data: ', error);
            }
        }
        return null;
    });
    const fetchFaqsData = (token) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // @ts-ignore
            const response = yield http_requests_1.ParametrosAPI.buscaFAQ('C', token);
            const { data } = response;
            if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
                setFaqsData(data);
            }
        }
        catch (error) {
            if (!axios_1.default.isCancel(error)) {
                console.log('error on request faqs data: ', error);
            }
        }
        return null;
    });
    const fetchPrefiltersData = (token) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // @ts-ignore
            const response = yield http_requests_1.ParametrosAPI.buscaDadosPrefiltros(token);
            const { data } = response;
            if (data && (data === null || data === void 0 ? void 0 : data.length) > 0)
                setPrefiltersData(data);
        }
        catch (error) {
            if (!axios_1.default.isCancel(error)) {
                console.log('error on request prefilters data: ', error);
            }
            setPrefiltersData(null);
        }
    });
    const changeLang = (lang) => {
        setLang(lang);
        i18n_1.default.changeLanguage(lang);
        localStorage.setItem(exports.langStorageIndex, lang);
    };
    const memoizedData = (0, react_1.useMemo)(() => ({
        lang,
        changeLang,
        accessByAccessibilityDetails,
        setAccessByAccessibilityDetails,
        onGoBackMobile,
        setOnGoBackMobile,
        mobileView,
        setMobileView,
        serviceData,
        setServiceData,
        faqsData,
        setFaqsData,
        featuredData,
        setFeaturedData,
        newsData,
        setNewsData,
        sectionsData,
        setSectionsData,
        isMobile,
        setIsMobile,
        base,
        setBase,
        selectedTab,
        setSelectedTab,
        headerTitle,
        changeHeaderTitle,
        showDestaques,
        siglaInstituicao,
        prefiltersData,
        setPrefiltersData
    }), [
        lang,
        accessByAccessibilityDetails,
        onGoBackMobile,
        mobileView,
        serviceData,
        faqsData,
        featuredData,
        newsData,
        sectionsData,
        isMobile,
        base,
        selectedTab,
        headerTitle,
        location,
        showDestaques,
        siglaInstituicao,
        prefiltersData,
    ]);
    return (react_1.default.createElement(AppContext.Provider, { value: memoizedData }, children));
};
const useAppContext = () => {
    const context = (0, react_1.useContext)(AppContext);
    if (context === undefined)
        throw new Error('useAppContext must be used within a AppContextProvider');
    return context;
};
exports.useAppContext = useAppContext;
exports.default = (0, react_router_dom_1.withRouter)(AppContextProvider);
